import _ from 'lodash';

export function classes(classList: string | Array<string> | Array<Array<string>>): string {
  let final: Array<string> | Array<Array<string>>;

  if (_.isString(classList)) {
    final = [classList as string];
  } else {
    final = classList as Array<string> | Array<Array<string>>;
  }

  return (final as Array<Array<string>>)
    .filter((cls) => cls && cls.length)
    .map((cls) => {
      return _.isArray(cls) ? classes(cls as string[]) : cls;
    })
    .join(' ');
}
